module.exports = __webpack_public_path__ + "img/_0.8a0d8e7b.png";